export function fmtBytes(n: number): string {
  if (n >= 1024 ** 3) return (n / 1024 ** 3).toFixed(1) + ' GB';
  if (n >= 1024 ** 2) return Math.max(1, Math.round(n / 1024 ** 2)) + ' MB';
  return Math.max(1, Math.round(n / 1024)) + ' KB';
}
export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
